import PropTypes from 'prop-types';
import React from 'react';
import { FiCheck } from 'react-icons/fi';
import * as Ui from './OptionToggleGroup.styles';

const OptionToggleGroup = ({ options, value, onChange, className }) => (
  <Ui.ToggleContainer className={className}>
    {options.map((option) => {
      const isActive = option.value === value;

      return (
        <Ui.ToggleOption key={option.value}>
          <Ui.ToggleButton
            type="button"
            $active={isActive}
            disabled={option.disabled}
            aria-pressed={isActive}
            onClick={() => !option.disabled && onChange(option.value, option)}
          >
            <Ui.Checkmark $active={isActive}>{isActive ? <FiCheck /> : null}</Ui.Checkmark>
            <Ui.ToggleContent>
              <Ui.ToggleTitle>{option.title}</Ui.ToggleTitle>
              {option.description ? (
                <Ui.ToggleDescription>{option.description}</Ui.ToggleDescription>
              ) : null}
            </Ui.ToggleContent>
          </Ui.ToggleButton>
        </Ui.ToggleOption>
      );
    })}
  </Ui.ToggleContainer>
);

OptionToggleGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.node,
      disabled: PropTypes.bool,
      title: PropTypes.node.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default OptionToggleGroup;
